export const REQUEST_REFERRER_POLICY: ReferrerPolicy = 'strict-origin-when-cross-origin';

export function getRequestReferrer(): string {
  if (typeof window === 'undefined') return 'about:client';
  return window.location.href;
}

export function applyRefererHeader(headers: Headers): Headers {
  const referrer = getRequestReferrer();
  if (referrer !== 'about:client') {
    headers.set('Referer', referrer);
  }
  return headers;
}

export function withRequestReferrer<T extends RequestInit>(init: T): T & Pick<RequestInit, 'referrer' | 'referrerPolicy'> {
  return {
    ...init,
    referrer: getRequestReferrer(),
    referrerPolicy: REQUEST_REFERRER_POLICY,
  };
}
